import { z } from 'zod';

import { SurveySchema } from './survey';
import { SurveyAnswersSchema } from './survey-answers';
import { makeEndpoint } from '../common';

export const PostSurveyRequestSchema = z.object({
  cartId: z.string().uuid(),
});

export const PostSurveyResponseSchema = SurveySchema;

export const PostSurveyAnswersRequestSchema = SurveyAnswersSchema;

export const PostSurveyEndpoint = makeEndpoint({
  method: 'POST',
  url: () => `v1/surveys`,
  requestSchema: PostSurveyRequestSchema,
  responseSchema: PostSurveyResponseSchema.optional(),
});

export const PostAnswersEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ surveyId }: { surveyId: string }) => `v1/surveys/${surveyId}/answers`,
  requestSchema: PostSurveyAnswersRequestSchema,
  responseSchema: z.void(),
});
